import { Badge } from '@shared/components/ui/badge'
import { AlertCircle, CheckCircle } from 'lucide-react'

interface ValidationStatusBadgeProps {
  isValidated: boolean
}

export function ValidationStatusBadge({ isValidated }: ValidationStatusBadgeProps) {
  if (isValidated) {
    return (
      <Badge variant="secondary" className="flex items-center gap-1">
        <CheckCircle className="w-3 h-3" />
        Cuenta validada
      </Badge>
    )
  }

  return (
    <Badge variant="destructive" className="flex flex-nowrap items-center gap-1">
      <AlertCircle className="w-3 h-3" />
      Pendiente
    </Badge>
  )
}
